import { render, staticRenderFns } from "./ODashboard.vue?vue&type=template&id=da6e8060&scoped=true&"
import script from "./ODashboard.vue?vue&type=script&lang=ts&"
export * from "./ODashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ODashboard.vue?vue&type=style&index=0&id=da6e8060&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6e8060",
  null
  
)

export default component.exports